const getAccess = (type: string) => {
  if (type.includes("SEAADE") && type.includes("IADR")) {
    return "SEAADE-IADR";
  } else if (type.includes("IADR")) {
    return "IADR";
  } else if (type.includes("SEAADE")) {
    return "SEAADE";
  }

  return "NONE";
};

export default getAccess;
